import React from 'react';
import { Cloud, CloudFog, CloudLightning, CloudRain, CloudSnow, Sun } from 'lucide-react';

interface WeatherIconProps {
  symbol: string;
  size?: number;
  className?: string;
}

export const WeatherIcon: React.FC<WeatherIconProps> = ({ symbol = 'clearsky_day', size = 16, className = '' }) => {
  const sym = (symbol || '').toLowerCase();
  if (sym.includes('clearsky') || sym.includes('fair')) {
    return <Sun size={size} className={`text-amber-400 shrink-0 ${className}`} />;
  }
  if (sym.includes('partlycloudy')) {
    return (
      <div className={`relative inline-flex items-center justify-center shrink-0 ${className}`} style={{ width: size, height: size }}>
        <Sun size={Math.max(8, size - 4)} className="text-amber-400 absolute -top-1 -right-1" />
        <Cloud size={size} className="text-[var(--text-secondary)]" />
      </div>
    );
  }
  if (sym.includes('thunder')) return <CloudLightning size={size} className={`text-amber-300 shrink-0 ${className}`} />;
  if (sym.includes('snow') || sym.includes('sleet')) return <CloudSnow size={size} className={`text-blue-200 shrink-0 ${className}`} />;
  if (sym.includes('rain') || sym.includes('shower')) return <CloudRain size={size} className={`text-blue-400 shrink-0 ${className}`} />;
  if (sym.includes('fog')) return <CloudFog size={size} className={`text-[var(--text-muted)] shrink-0 ${className}`} />;
  return <Cloud size={size} className={`text-[var(--text-secondary)] shrink-0 ${className}`} />;
};

export default WeatherIcon;
